



const CONSTANTS = {
    consoleEnabled: false
}



export default CONSTANTS